import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/lib/apiClient'

export interface PublicStats {
  top_pick_performance: {
    win_rate: number | null
    roi: number | null
    n_picks: number
  }
  plans: Record<string, number>
  currency: string
  free_trial_days: number
}

export function usePublicStats() {
  return useQuery<PublicStats>({
    queryKey: ['public', 'stats'],
    queryFn: async () => (await apiClient.get('/api/public/stats')).data,
    staleTime: 5 * 60_000,
  })
}
